import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { PopUpContainer } from "assets/css/globle";
import { useTranslation } from "react-i18next";

const ErrorPopup = ({ openErrorModal, setOpenErrorModal }) => {
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 444,
    bgcolor: "background.paper",
    // boxShadow: 24,
    width: "100%",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "4px",
    outline: "none",
  };

  const { t } = useTranslation();
  return (
    <Modal
      open={openErrorModal}
      onClose={() => {
        setOpenErrorModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      maxWidth="sm"
    >
      <Box sx={style1}>
        <PopUpContainer>
          <h2>{t("Error_saving_Action_Zone")}</h2>
          <div className="action-btn">
            <button
              onClick={() => {
                setOpenErrorModal(false);
              }}
            >
              {t("Ok")}
            </button>
          </div>
        </PopUpContainer>
      </Box>
    </Modal>
  );
};

export default ErrorPopup;
